import templateUrl from 'servicestack/email/send-email-prompt.htm'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'

export const DEFAULT_COMMAND_URL = 'SendEmail.json';

export default class SendEmailPromptController {
	constructor($uibModalInstance, options) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.modal = $uibModalInstance;
		$ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
		$ctrl.$close = $ctrl.close = $uibModalInstance.close;
			$ctrl.bus = new ServiceBus();
		$ctrl.title = options.title || options.heading || 'Send an email...';
		$ctrl.options = options;
		$ctrl.model = Object.assign({}, options.model);
		console.debug('SendEmailPromptController', { options, $ctrl });
		if (!$ctrl.emailIsValid($ctrl.model.from)) $ctrl.model.from = "";
	}

	emailIsValid(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}

	toggleRecipient(recipient, fieldName = 'to') {
		let $ctrl = this;
		let recipients = ($ctrl.model[fieldName] || '').split(/[,^;:<>!?\n\s\r]+/).filter(r => r && r.length);
		let index = recipients.indexOf(recipient);
		if (index >= 0) {
			recipients.splice(index, 1);
		} else {
			recipients.push(recipient);
		}
		$ctrl.model[fieldName] = recipients.join(', ');
	}

	submit() {
		const $ctrl = this;
		$ctrl.submitting = new Date();
		$ctrl.bus.send($ctrl.getCommandUrl(), $ctrl.getCommand())
			.then(res => $ctrl.onSubmitted(res))
			.finally(() => $ctrl.afterSubmitted());
	}

	getCommand() {
		const $ctrl = this;
		return $ctrl.model;
	}

	getCommandUrl() {
		return DEFAULT_COMMAND_URL;
	}

	onSubmitted(res) {
		const $ctrl = this;
		$ctrl.$close(res);
	}

	afterSubmitted() {
		const $ctrl = this;
		$ctrl.submitting = null;
	}
};